export default __webpack_public_path__ + "static/media/image5.4e7d436d.jpeg";